module.exports = __webpack_public_path__ + "static/RoslindaleText-Bold-300852350b312ba7cbafc3118f2de20e.woff2";